var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Testpage")]),_c('p',[_vm._v("id: "+_vm._s(_vm.id))]),_c('p',[_vm._v("slug: "+_vm._s(_vm.slug))])])
}
var staticRenderFns = []

export { render, staticRenderFns }